import React, { useMemo, useState } from 'react';
import { useBespokeMarketsState } from '@apollo/core';
import { isEmpty } from 'lodash';
import { BET_EVENT_TYPE } from '@apollo/core/src/constants';
import cx from 'classnames';
import Label from '../../shared/components/I18n/Label';
import MainBody from '../../shared/components/MainBody/MainBody';
import BespokeMarket from './BespokeMarket';
import Loader from '../../shared/components/Loader';

const EVENT_TYPES = ['ANY', BET_EVENT_TYPE.RACING, BET_EVENT_TYPE.SPORT_PREMATCH];

const BespokeMarketsPage = () => {
  const { markets, loading } = useBespokeMarketsState();

  const [selectedType, setSelectedType] = useState(EVENT_TYPES[0]);

  const filteredMarkets = useMemo(
    () => markets
      .filter((market) => selectedType === 'ANY' || market.sportService === selectedType)
      .sort((a, b) => new Date(a?.eventStartTime) - new Date(b?.eventStartTime)),
    [markets, selectedType],
  );

  if (loading) {
    return <Loader />;
  }

  if (isEmpty(markets)) {
    return (
      <div className='nothing-found--bespoke_markets'>
        <h3 className='nothing-found'>
          <Label message='nothing_found_bespoke' />
        </h3>
        <p className='nothing-found-label'>
          <Label message='nothing_found_bespoke_markets' />
        </p>
      </div>
    );
  }

  return (
    <div className='main__page main__page--bespoke'>
      <MainBody className='main__body--bespoke'>
        <div className='sport-page__header sport-page__header--promotions'>
          <h1 className='sport-name'>
            <Label message='bespoke markets' />
          </h1>
        </div>
        <div className='filter__wrapper bespoke-filters'>
          {EVENT_TYPES.map((type) => (
            <div
              key={type}
              className={cx('filter-item', { active: selectedType === type })}
              onClick={() => setSelectedType(type)}
            >
              <Label message={type === 'ANY' ? 'all' : type} />
            </div>
          ))}
        </div>
        <div className='bespoke-market__list'>
          {filteredMarkets.length > 0 ? (
            filteredMarkets?.map((market) => (
              <BespokeMarket bespokeMarket={market} key={market.id} />
            ))
          ) : (
            <div className='no-bespoke-message'>
              <h3>
                <Label message='no_bespoke_available' />
              </h3>
              <Label message='check_bespoke_later' />
            </div>
          )}
        </div>
      </MainBody>
    </div>
  );
};

export default BespokeMarketsPage;
